import config from '../config'
import { IFontData } from '../data/mainSkinData'
import { addFont } from './fonts'

interface IFontDataCache {
	name: string
}

const loadedFonts: IFontDataCache[] = []

const loadFonts = (fonts: IFontData[]) => {
	try {
		fonts.forEach((font) => {
			addFont(font.name, font.family)

			const fontIndex = loadedFonts.findIndex((cachedFont) => cachedFont.name === font.name)

			if (fontIndex === -1) {
				loadedFonts.push({
					name: font.name,
				})
				const fontFace = new FontFace(font.name, `url(${config.getAssetsPath()}${font.url})`)
				fontFace
					.load()
					.then(() => {
						document.fonts.add(fontFace)
					})
					.catch(() => {
						// console.log(err)
					})
			}
		})
	} catch (err) {
		// console.log('ERR: ', err)
		// Font Face not supported
	}
}

export default loadFonts
